<template>
  <b-card class="telecaller-leaderboard" v-if="hasRight(user, 'dashboard', 'view')" no-body>
    <template #header>
      <h6 class="mb-0">Top Telecallers</h6>
    </template>
    <b-card-body>
      <b-table :items="telecallers" :fields="fields" per-page="5" small striped responsive></b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BTable } from 'bootstrap-vue';
import { hasRight } from '@/utils/auth';
import { dashboardGet } from './dashboardApi';

export default {
  name: 'TelecallerLeaderboard',
  components: {
    BCard,
    BCardBody,
    BTable,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    dashboardData: { type: Object, default: null },
    useAggregate: { type: Boolean, default: false },
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },
  data() {
    return {
      fields: [
        { key: 'telecaller_name', label: 'Telecaller' },
        { key: 'total_leads_called', label: 'Leads Called' },
        { key: 'total_calls', label: 'Total Calls' },
        { key: 'connected_calls', label: 'Connected Calls' },
        { key: 'connection_rate', label: 'Connection Rate (%)' },
      ],
      telecallers: [],
    };
  },
  watch: {
    dashboardData: {
      deep: true,
      handler(val) {
        if (val && val.telecaller_leaderboard != null && hasRight(this.user, 'dashboard', 'view')) {
          this.telecallers = Array.isArray(val.telecaller_leaderboard) ? [...val.telecaller_leaderboard] : [];
        }
      },
    },
    filters: {
      deep: true,
      immediate: true,
      handler() {
        if (!hasRight(this.user, 'dashboard', 'view')) return;
        if (this.useAggregate) {
          if (this.dashboardData && this.dashboardData.telecaller_leaderboard != null) this.telecallers = Array.isArray(this.dashboardData.telecaller_leaderboard) ? [...this.dashboardData.telecaller_leaderboard] : [];
          return;
        }
        if (this.dashboardData && this.dashboardData.telecaller_leaderboard != null) { this.telecallers = Array.isArray(this.dashboardData.telecaller_leaderboard) ? [...this.dashboardData.telecaller_leaderboard] : []; return; }
        this.fetchTelecallerLeaderboardData();
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (hasRight(newVal, 'dashboard', 'view')) {
          if (this.useAggregate) {
            if (this.dashboardData && this.dashboardData.telecaller_leaderboard != null) this.telecallers = Array.isArray(this.dashboardData.telecaller_leaderboard) ? [...this.dashboardData.telecaller_leaderboard] : [];
            return;
          }
          this.fetchTelecallerLeaderboardData();
        } else {
          this.telecallers = [];
        }
      },
    },
  },
  methods: {
    hasRight, // Make the helper available in the template
    async fetchTelecallerLeaderboardData() {
      if (!hasRight(this.user, 'dashboard', 'view')) return;
      if (this.useAggregate || (this.dashboardData && this.dashboardData.telecaller_leaderboard != null)) {
        if (this.dashboardData && this.dashboardData.telecaller_leaderboard != null) this.telecallers = Array.isArray(this.dashboardData.telecaller_leaderboard) ? [...this.dashboardData.telecaller_leaderboard] : [];
        return;
      }
      try {
        const response = await dashboardGet(this.baseApi, this.accessToken, '/dashboard/crm/telecaller-leaderboard', this.filters);
        const raw = response.data && response.data.data;
        this.telecallers = Array.isArray(raw) ? [...raw] : [];
      } catch (error) {
        console.error('Error fetching telecaller leaderboard data:', error);
        // Handle error
      }
    },
  },
};
</script>

<style scoped>
.telecaller-leaderboard {
  margin-top: 20px;
}
</style>